import { render, staticRenderFns } from "./publication-report-v2.vue?vue&type=template&id=4018ce34&scoped=true&"
import script from "./publication-report-v2.vue?vue&type=script&lang=js&"
export * from "./publication-report-v2.vue?vue&type=script&lang=js&"
import style0 from "./publication-report-v2.vue?vue&type=style&index=0&id=4018ce34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4018ce34",
  null
  
)

export default component.exports